// extracted by mini-css-extract-plugin
export var acceptButton = "_2z-5";
export var fullContent = "_2z-4";
export var link = "_2z-6";
export var linkIcon = "_2z-7";
export var sideContent = "_2z-3";
export var sideImage = "_2z-2";
export var sideImageWrapper = "_2z-1";
export var splitLayout = "_2z-0";